/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  appName?: string;
  canExtendTrial: boolean;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
};

export const PremiumAppUpgradeNudge = ({
  appName,
  canExtendTrial,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
    onUpgradeClick,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton
      key="extend-trial"
      onClick={onExtendTrialClick}
      text="Try Professional"
    />
  ) : (
    <CancelButton key="cancel" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        secondaryButton,
        <UpgradeButton
          key="upgrade"
          onClick={onUpgradeClick}
          text={activeView.upgradeButtonText}
        />,
      ]}
      headingText="Unlock premium apps to continue"
      id="premium"
      image={<NudgeImage appName={appName} type={upgradeReasons.premium} />}
      subtitleText="Premium Feature"
    />
  );
};
